module.exports = __webpack_public_path__ + "img/select-arrow.6120cecd.svg";